<script setup lang="ts">
const aggregator = import.meta.env.VITE_APP_CUSTOM_THEME_AGGREGATOR ?? 'Bridgit';
</script>

<template>
  <main class="fixed inset-0 overflow-y-auto bg-bridgit-paleBlue px-5 py-8 sm:px-8 sm:py-12">
    <section class="mx-auto flex min-h-full max-w-6xl items-center justify-center">
      <div
        class="w-full max-w-5xl rounded-3xl bg-white px-6 py-16 text-center shadow-xl shadow-slate-900/5 sm:px-14 sm:py-24"
      >
        <svg viewBox="0 0 48 48" class="mx-auto h-16 w-16 text-bridgit-vibrantGreen" fill="none" aria-hidden="true">
          <path
            d="M20.6 7h6.8l1.1 5a14 14 0 0 1 3.4 2l4.9-1.5 3.4 5.9-3.8 3.5a14 14 0 0 1 0 4l3.8 3.5-3.4 5.9-4.9-1.5a14 14 0 0 1-3.4 2l-1.1 5h-6.8l-1.1-5a14 14 0 0 1-3.4-2l-4.9 1.5-3.4-5.9 3.8-3.5a14 14 0 0 1 0-4l-3.8-3.5 3.4-5.9 4.9 1.5a14 14 0 0 1 3.4-2l1.1-5Z"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle cx="24" cy="24" r="6" stroke="currentColor" stroke-width="3" />
        </svg>

        <h1 class="mt-12 text-3xl font-bold tracking-tight text-bridgit-navy sm:text-5xl">
          We’re doing a little housekeeping
        </h1>
        <p class="mx-auto mt-8 max-w-4xl text-lg leading-8 text-bridgit-lightGrey sm:text-2xl sm:leading-10">
          The {{ aggregator }} Loan Application is temporarily offline while we perform a scheduled upgrade.
        </p>
        <p class="mx-auto mt-8 max-w-4xl text-lg leading-8 text-bridgit-lightGrey sm:text-2xl sm:leading-10">
          We expect this technical maintenance to take up to 3 hours, with systems back online by 5:00am AEST, Sunday 26
          July. We appreciate your patience and apologise for any inconvenience.
        </p>
      </div>
    </section>
  </main>
</template>
